import React from 'react'

import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import { CustomEllipsis } from '@app/constants/customEllipsis'
import { ColumnWidth } from '@app/constants/columnWidth'

import { columnTitleMap } from '../configs'
import { CountWithStatusRender } from '../ui/CountWithStatusRender'

import type { Column } from '@app/components/base/Table/types'
import type { ColumnsKeys, QuotaReportsColumns } from '@app/pages/QuotaReportPage/Tabs/QuotaReportTab/types'

const getOptions = (): Array<Column<QuotaReportsColumns>> => {
  const columnsKeys = Object.keys(columnTitleMap).filter(
    key => !['brandProduct', 'eppChtmProduct'].includes(key)
  ) as ColumnsKeys

  return columnsKeys.map(key => {
    const column: Column<QuotaReportsColumns> = {
      customEllipsis: CustomEllipsis,
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...ColumnWidth
    }

    return column
  })
}

export const getColumns = (): Array<Column<QuotaReportsColumns>> => {
  return getColumnsFromMap<QuotaReportsColumns>({
    columnTitleMap,
    options: [
      ...getOptions(),
      {
        key: 'brandProduct',
        sorter: (a, b) => sorterDispatcher(a.brandProduct.count, b.brandProduct.count),
        render: (_, { brandProduct }) => (
          <CountWithStatusRender
            status={ brandProduct.status }
            count={ brandProduct.count }
          />
        )
      },
      {
        key: 'eppChtmProduct',
        sorter: (a, b) => sorterDispatcher(a.eppChtmProduct.count, b.eppChtmProduct.count),
        render: (_, { eppChtmProduct }) => (
          <CountWithStatusRender
            status={ eppChtmProduct.status }
            count={ eppChtmProduct.count }
          />
        )
      }
    ]
  })
}
